import { EUsageTime } from 'pages/repoImport/enums'

export const C_TIMES_USAGE = [
  EUsageTime.Morning,
  EUsageTime.Midday,
  EUsageTime.Afternoon,
  EUsageTime.Night
]
